export const Community: React.FC = () => {
  return <div>Comming soon</div>;
};
